import { processData, sumDataForSimpleChart, aggregateMultiLevelObj } from './processForChart';
import { makeTableColumn } from './processForTable';
import CartesianSeries from './CartesianSeries';
import PolarSeries from './PolarSeries';

// This goes through the processing sequence to generate necessary data.
// Once processing is done, update the component state.
// TODO: Might be a good idea to break the process into smaller functions as
// the process is getting complex.
const fullProcessSequence = (that, selectedConfig) => {
  const { data } = that.props;
  const { currentConfig } = that.state;

  if (data.no_data_message) {
    // no data available
    return;
  }

  const displayList = data.display;
  const newCurrentConfig = selectedConfig
    || currentConfig
    || (displayList && Object.keys(displayList)[0]);
  const config = newCurrentConfig && displayList[newCurrentConfig];

  // singleLevelRangeGroupList is stored so that actions in clickable chart elements
  // can be easily identified.
  const aggregateOrEmpty = configObj => (typeof configObj === 'object')
    ? aggregateMultiLevelObj(configObj) : {};
  const singleLevelRangeGroupList = config && Object.assign(
    config.sum ? { [config.sum]: {} } : { amount: {} }, // sum is defined or a counted amount.
    aggregateOrEmpty(config.range),
    aggregateOrEmpty(config.groups),
  );

  // Define available chart components.
  const componentMap = {
    polar: PolarSeries,
    cartesian: CartesianSeries,
  };

  // Set which chart is going to be based on series prop in data. Default is cartesian.
  let chartSeries;
  let chartData;
  let chartDataTotal = null;
  let chartLegendItems = [];
  if (config) {
    const { series = 'cartesian', groupsAsXaxis } = config;
    chartSeries = componentMap[series];

    // Initiate processing the data for charts.
    chartData = processData({
      unprocessedData: data,
      range: config.range,
      sum: config.sum,
      groups: config.groups,
      rangeOrder: config.rangeOrder,
    });

    // All refLine should not be shown in legend nor consider as data.
    const sumChartData = sumDataForSimpleChart(chartData, config.sum)
      .filter(item => (singleLevelRangeGroupList[item.name].type !== 'refLine'));

    if (sumChartData) {
      // Generate custom chart legend object - we need to take filter into consideration
      // when showing the legend.
      chartLegendItems = sumChartData
        .map((item) => {
          const { name } = item;
          const itemConfig = singleLevelRangeGroupList[name] || {};
          return ({ // This is a ReChart payload.
            value: name,
            id: name,
            type: 'line',
            color: itemConfig.color || '#777',
          });
        });

      // Calculate the real chart total unless no chart data, which will remain null.
      chartDataTotal = +sumChartData.reduce((acc, curr) => {
        const propToSum = curr[config.sum];
        // eslint-disable-next-line no-restricted-globals
        if (!isNaN(propToSum)) {
          return propToSum + acc;
        }
        return acc;
      }, 0).toFixed(2);
    }

    // Polar based chart and simple cartesian chart requires summing all range data.
    if (series === 'polar' || groupsAsXaxis) {
      chartData = sumChartData;
    }
  }

  // Generate table data based on the processed data.

  const tableColumn = makeTableColumn(data);

  const tableData = data.data;

  // Update state to make changes to the visualisation
  that.setState({
    displayList,
    singleLevelRangeGroupList,
    chartData,
    chartDataTotal,
    chartLegendItems,
    chartSeries,
    tableColumn,
    tableData,
    currentConfig: newCurrentConfig,
    currentView: (!displayList[newCurrentConfig] || newCurrentConfig === 'table') ? 'table' : 'chart',
    header: (displayList[newCurrentConfig] && newCurrentConfig !== 'table') ? displayList[newCurrentConfig].title : '',
  });
};

export default fullProcessSequence;
